import { UseCase } from '../../base/UserCase';
import { Observable} from 'rxjs';
import { UserRepository } from '../../repositories/UserRepository';
import { Injectable } from '@angular/core';
import { UserDTO, UserRequestDTO } from '../../../data/dto/UserDTO';

@Injectable({
    providedIn: 'root'
})
export class LoginUserUseCase implements UseCase<UserRequestDTO, UserDTO> {

    constructor(
        private userRepository: UserRepository,

    ) { }

    execute(request: UserRequestDTO): Observable<UserDTO> {
        return this.userRepository.login(request);
    }
}
